export type ModalEventType = 'load' | 'close' | 'reduce' | 'unreduce' | 'dismiss';

export interface IModalEvent {
  type: ModalEventType;
  component: string;
}

export class ModalEvent implements IModalEvent {
  constructor(public readonly type: ModalEventType, public readonly component: string) {}
  private static of(type: ModalEventType, component: string) {
    return new ModalEvent(type, component);
  }
  public static load(component: string) {
    return this.of('load', component);
  }
  public static close(component: string) {
    return this.of('close', component);
  }
  public static dismiss(component: string) {
    return this.of('dismiss', component);
  }
  public static reduce(component: string) {
    return this.of('reduce', component);
  }
  public static unreduce(component: string) {
    return this.of('unreduce', component);
  }
}
